import Qs from "qs"

const initialState = {
  code: null,
  coalesced: null,
  email: null,
  id: null,
  login: null,
  signedIn: false,
  authRequested: false,
  tier: null,
}

export const loginUser = () => (dispatch, getState) => {
  const { user, config } = getState()
  const url = `${config.resetLoginPath}?${Qs.stringify({
    email: user.emailToCoalesce,
    return_to: window.location.href,
  })}`
  window.location.assign(url) // no turbolinks for login to avoid multiple redirects
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case "SET_USER": {
      return {
        ...state,
        email: action.payload.email || null,
        id: action.payload.id || null,
        login: action.payload.login || null,
        signedIn: action.payload.signedIn,
        availableClients: action.payload.available_clients || null,
        code: action.payload.code,
        tier: action.payload.tier,
      }
    }

    case "USER_AUTH_REQUESTED": {
      return {
        ...state,
        authRequested: action.payload,
      }
    }

    default: {
      return state
    }
  }
}
